import { render, staticRenderFns } from "./PrintQuestion.vue?vue&type=template&id=212b0f0a&scoped=true&"
import script from "./PrintQuestion.vue?vue&type=script&lang=js&"
export * from "./PrintQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PrintQuestion.vue?vue&type=style&index=0&id=212b0f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b0f0a",
  null
  
)

/* custom blocks */
import block0 from "./PrintQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212b0f0a')) {
      api.createRecord('212b0f0a', component.options)
    } else {
      api.reload('212b0f0a', component.options)
    }
    module.hot.accept("./PrintQuestion.vue?vue&type=template&id=212b0f0a&scoped=true&", function () {
      api.rerender('212b0f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print/report/survey-analysis/PrintQuestion.vue"
export default component.exports